import { render } from "./ReversePickupNew.vue?vue&type=template&id=336b8b05&scoped=true"
import script from "./ReversePickupNew.vue?vue&type=script&lang=js"
export * from "./ReversePickupNew.vue?vue&type=script&lang=js"

import "./ReversePickupNew.vue?vue&type=style&index=0&id=336b8b05&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336b8b05"]])

export default __exports__